module.exports = __webpack_public_path__ + "static/media/report-orange.aea1f2bc.svg";